import { Component, OnInit } from "@angular/core";
import { defineLocale    } from "ngx-bootstrap/chronos";
import { nlLocale } from "ngx-bootstrap/locale";
import { LoadingService } from "@services/loading.service";
import { delay } from "rxjs";

@Component({
    selector: "npi-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent implements OnInit {
  public loading$ = this.loadingService.isLoading().pipe(delay(0));

  constructor(private loadingService: LoadingService) {}

  ngOnInit(): void {
    defineLocale("nl", nlLocale);
  }
}
